import { Components, Theme } from '@mui/material'
import { Asterisk } from 'lucide-react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

type AlertColorKey = string

const customAlertColorMap: Record<AlertColorKey, object> = {
  birth: Colors.reproduction.birth,
  challenge: Colors.health.challenge,
  critical: Colors.health.critical,
  danger: {
    backgroundColor: Colors.feedback.danger.backgroundColor,
    color: Colors.feedback.danger.color,
  },
  dev: {
    backgroundColor: Colors.devmode,
    color: 'white',
  },
  error: {
    backgroundColor: Colors.feedback.danger.backgroundColor,
    color: Colors.feedback.danger.color,
  },
  heat: Colors.reproduction.heat,
  info: {
    backgroundColor: Colors.feedback.info.backgroundColor,
    color: Colors.feedback.info.color,
  },
  neutral: {
    backgroundColor: Colors.feedback.regular.backgroundColor,
    color: Colors.feedback.regular.color,
  },
  normal: Colors.health.normal,
  observation: Colors.health.observation,
  success: {
    backgroundColor: Colors.feedback.success.backgroundColor,
    color: Colors.feedback.success.color,
  },
  warning: {
    backgroundColor: Colors.feedback.warning.backgroundColor,
    color: Colors.feedback.warning.color,
  },
}

export function OverridedAlert(theme: Theme): Components {
  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          danger: <Icon name="circle-alert" size={22} />,
          dev: <Asterisk size={22} />,
          neutral: <Icon name="lucide-info" size={22} />,
        },
      },
      styleOverrides: {
        action: {
          paddingTop: 0,
        },
        icon: {
          color: 'inherit !important',
        },
        root: ({ ownerState }) => {
          const colorKey = ownerState.color || ownerState.severity
          const customColorStyles = colorKey ? (customAlertColorMap[colorKey] ?? {}) : {}

          return {
            borderRadius: 16,
            display: 'flex',
            fontSize: '14px',
            maxWidth: '100%',
            [theme.breakpoints.up('sm')]: {
              flexDirection: 'row !important',
            },
            [theme.breakpoints.up('xs')]: {
              flexDirection: 'column',
            },
            width: '100%',
            ...customColorStyles,
          }
        },
      },
    },
  }
}
